import React, { FC, ReactNode } from 'react'

import s from './WixMobileDescription.scss'

interface WixMobileDescriptionProps {
  dataHook?: string
  children?: ReactNode
}

export const WixMobileDescription: FC<WixMobileDescriptionProps> = ({ children, dataHook }) => {
  return (
    <p className={s.description} data-hook={dataHook}>
      {children}
    </p>
  )
}
